import React, { useState } from "react";
import "../datatable.scss";
import { Space, Input, Button, Tag, Popover, Image } from "antd";
import type { ColumnsType } from "antd/es/table";
import {
  EditOutlined,
  DeleteOutlined,
  SyncOutlined,
  PlayCircleOutlined,
  CheckOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { AppTable } from "../../common";

interface Contentdata {
  key?: string;
  _id: string;
  title: string;
  video: string;
  description: string;
  meta_keywords: any;
  status: string;
  publishOn: any;
  thumbnail: string;
}

function DataTableLatestVideos({
  updateVideoStatusToarchived,
  updateVideoStatusTopublished,
  setshowModel,
  setEditable,
  isOpen,
  contentData,
  deleteOtherVideoContent,
  editContent,
  showModal,
}: any) {
  const [searchText, setSearchText] = useState("");

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) => a._id.localeCompare(b._id),
      onFilter: (value, record) => {
        return (
          String(record.title).toLowerCase().includes(value.toLocaleString()) ||
          String(record._id).toLowerCase().includes(value.toLocaleString()) ||
          String(record.title).toLowerCase().includes(value.toLocaleString()) ||
          String(record.title).toUpperCase().includes(value.toLocaleString()) ||
          String(record.status).toLowerCase().includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   key: "description",
    //   render: (_, record) => (
    //     <>
    //       <p
    //         dangerouslySetInnerHTML={{
    //           __html: record?.description?.slice(0, 100),
    //         }}
    //       />
    //     </>
    //   ),
    // },
    {
      title: "Video",
      dataIndex: "video",
      key: "video",
      width: 150,
      render: (_, record) => (
        <a
          className="table_pill_btn table_pill_btn--view"
          href={record.video}
          target="_blank"
          rel="noreferrer"
        >
          <PlayCircleOutlined /> See Video
        </a>
      ),
    },
    // {
    //   title: "Thumnail",
    //   dataIndex: "thumbnail",
    //   key: "thumbnail",
    //   render: (_, record) => (
    //     <Space>
    //       <Image
    //         width={80}
    //         height={80}
    //         src={record.thumbnail ? record.thumbnail : "noavatar.png"}
    //         alt="thumbnail"
    //       />
    //     </Space>
    //   ),
    // },
       {
      title: "Date",
      dataIndex: "publishOn",
      key: "publishOn",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (_, record) => (
        <Space>
          <Tag color={record.status === "active" ? "green" : "red"}>
            {record.status}
          </Tag>
        </Space>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Popover
            overlayClassName="status_popover"
            content={
              <div className="status_popover__actions">
                <Button
                  className="status_popover__btn status_popover__btn--approve"
                  icon={<CheckOutlined />}
                  onClick={() => updateVideoStatusTopublished(record._id)}
                >
                  Publish
                </Button>
                <Button
                  className="status_popover__btn status_popover__btn--reject"
                  icon={<InboxOutlined />}
                  onClick={() => updateVideoStatusToarchived(record._id)}
                >
                  Archive
                </Button>
              </div>
            }
            title="Status Change"
          >
            <Button
              className="table_pill_btn table_pill_btn--status"
              icon={<SyncOutlined />}
            >
              Status
            </Button>
          </Popover>
          <Button
            onClick={() => {
              setshowModel(!isOpen);
              setEditable(true);
              editContent(record._id);
            }}
            className="table_pill_btn table_pill_btn--view"
            icon={<EditOutlined />}
          >
            Edit
          </Button>
          <Popover
            content={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <Button
                  style={{
                    backgroundColor: "green",
                    width: "100%",
                    color: "#fff",
                  }}
                  onDoubleClick={() => deleteOtherVideoContent(record._id)}
                >
                  Yes
                </Button>
              </div>
            }
            title="Please Double click to delete."
          >
            <Button
              className="table_pill_btn table_pill_btn--danger"
              icon={<DeleteOutlined />}
            >
              Delete
            </Button>
          </Popover>
        </Space>
      ),
    },
  ];

  return (
    <div className="dataTable">
      <div className="filterMenu">
        <Button onClick={showModal} className="add_button">
          Add New Events Video
        </Button>
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
    </div>
  );
}

export default DataTableLatestVideos;
